<p-dialog
  [visible]="visible"
  (visibleChange)="handlePrimeNgVisibleChange($event)"
  [modal]="true"
  [showHeader]="false"
  [closable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="nkd-dialog"
  maskStyleClass="nkd-mask"
  [style]="{ width: '500px' }"
>
  <div class="nkd" (keydown)="onKeydown($event)" tabindex="0">
    <!-- Header -->
    <div class="nkd__header">
      <div class="nkd__header-text">
        <span class="nkd__label">{{ label }}</span>
        <span class="nkd__sub-label" *ngIf="subLabel">{{ subLabel }}</span>
      </div>
      <button
        type="button"
        class="nkd__close-btn"
        (click)="onCancelClick()"
        aria-label="Close without saving"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Value readout -->
    <div class="nkd__display">
      <span class="nkd__display-value">{{ displayValue }}</span>
      <span class="nkd__display-unit" *ngIf="unit">{{ unit }}</span>
    </div>

    <!-- Keypad -->
    <div class="nkd__grid">
      <button type="button" class="nkd__key" (click)="onDigit('7')">7</button>
      <button type="button" class="nkd__key" (click)="onDigit('8')">8</button>
      <button type="button" class="nkd__key" (click)="onDigit('9')">9</button>

      <button type="button" class="nkd__key" (click)="onDigit('4')">4</button>
      <button type="button" class="nkd__key" (click)="onDigit('5')">5</button>
      <button type="button" class="nkd__key" (click)="onDigit('6')">6</button>

      <button type="button" class="nkd__key" (click)="onDigit('1')">1</button>
      <button type="button" class="nkd__key" (click)="onDigit('2')">2</button>
      <button type="button" class="nkd__key" (click)="onDigit('3')">3</button>

      <button
        type="button"
        class="nkd__key nkd__key--clear"
        (click)="onClear()"
        title="Clear"
      >
        C
      </button>
      <button type="button" class="nkd__key" (click)="onDigit('0')">0</button>
      <button
        type="button"
        class="nkd__key nkd__key--backspace"
        (click)="onBackspace()"
        title="Backspace"
      >
        <i class="pi pi-delete-left"></i>
      </button>
    </div>

    <!-- Confirm -->
    <button type="button" class="nkd__ok-btn" (click)="onConfirmClick()">
      <i class="pi pi-check"></i>
      <span>OK</span>
    </button>
  </div>
</p-dialog>
